module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "login-page-wrapper profile",
    class: {
      'bodyfont-unauth': !_vm.user
    }
  }, [_c('div', {
    staticClass: "over-lay"
  }), _vm._v(" "), _c('div', {
    staticClass: "container "
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "main-content"
  }, [_c('h3', {
    staticClass: "heading",
    style: ({
      color: _vm.getCorpHeadingColor
    })
  }, [_vm._v("FAQ")])])]), _vm._v(" "), _vm._l((_vm.allFAQ), function(section) {
    return (_vm.allFAQ) ? _c('div', {
      staticClass: "col-md-12 text-left"
    }, [_c('legend', {
      style: ({
        color: _vm.getCorpHeadingColor
      })
    }, [_vm._v(_vm._s(section.headerName))]), _vm._v(" "), _vm._l((section.lstFaqs), function(faq) {
      return _c('div', [_c('p', [_c('strong', {
        domProps: {
          "innerHTML": _vm._s(faq.question)
        }
      })]), _vm._v(" "), _c('p', {
        domProps: {
          "innerHTML": _vm._s(faq.response)
        }
      }), _vm._v(" "), (faq.faqVideoUrl) ? _c('p', [_c('a', {
        attrs: {
          "target": "new",
          "href": faq.faqVideoUrl
        }
      }, [_vm._v("Learn More")])]) : _vm._e(), _vm._v(" "), (faq.faqImageUrl) ? _c('p', [_c('img', {
        attrs: {
          "src": faq.faqImageUrl
        }
      })]) : _vm._e(), _vm._v(" "), _c('br')])
    })], 2) : _vm._e()
  })], 2)])])
},staticRenderFns: []}


// WEBPACK FOOTER //
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e7c1a724"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/string-replace-loader?{"search":"pk_test_6pRNASCoBOKtIshFeQd4XMUh","replace":"pk_live_NgwNoBs3GAlrsSez07Zyh4Jc"}!./~/string-replace-loader?{"search":"https:/www1.dev-tonenetworks.com","replace":"https:/www.tonenetworks.com"}!./~/string-replace-loader?{"search":"https:/s3.amazonaws.com/tone-assets/app/navigation","replace":"https:/assets.tonenetworks.com/app/navigation"}!./~/string-replace-loader?{"search":"sandbox_2yn8x45w_k2v4j3d55x4gh6xz","replace":"production_6r7mxqgh_htw3nq9wp32w8h2x"}!./src/components/FAQ.vue